import { Box, Paper, Typography } from "@mui/material";
import NewReleasesIcon from '@mui/icons-material/NewReleases';

export default function PaperMUI({
    children,
    featEmBreve = false
}: PaperMUIProps) {
    return (
        <Box component={Paper} height="100%" position="relative">
            {
                featEmBreve &&
                <Box
                    width="100%"
                    height="100%"
                    position="absolute"
                    top={0}
                    left={0}
                    zIndex={99}
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    sx={{
                        backdropFilter: 'blur(2px)'
                    }}
                >
                    <Box
                        p={2}
                        gap={1}
                        borderRadius={1}
                        display="flex"
                        alignItems="center"
                        sx={{
                            backgroundColor: "transparent"
                        }}
                    >
                        <NewReleasesIcon fontSize="large" sx={{ color: "#388e3c" }} />

                        <Typography
                            variant="h5"
                            fontWeight="bold"
                            color="#388e3c"
                            textTransform="uppercase"
                        >
                            Em Breve
                        </Typography>
                    </Box>
                </Box>
            }
            {children}
        </Box>
    )
}

interface PaperMUIProps {
    children: React.ReactNode
    featEmBreve?: boolean,
}